module.exports = __webpack_public_path__ + "static/media/arrow-icon-full-red-down.d9a6669f.svg";